import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0, a1, a2, a3, a5, a6) { return [a0, a1, a2, a3, "ma", a5, a6]; };
function TagHighlightComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵlistener("click", function TagHighlightComponent_div_0_ng_container_5_Template_span_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const i_r4 = ctx.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.setActiveArea($event, i_r4); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ma_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const isFirst_r5 = ctx.first;
    const isLast_r6 = ctx.last;
    const isOdd_r7 = ctx.odd;
    const isEven_r8 = ctx.even;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(2, _c0, isLast_r6 ? "last" : "", isFirst_r5 ? "first" : "", isOdd_r7 ? "odd" : "", isEven_r8 ? "even" : "", "ma-" + i_r4, ctx_r1.selectMainAreaArray.indexOf(ma_r3) > -1 ? "active" : ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ma_r3);
} }
function TagHighlightComponent_div_0_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = function (a0, a1, a2, a3, a5, a6) { return [a0, a1, a2, a3, "tag", a5, a6]; };
function TagHighlightComponent_div_0_ng_container_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext();
    const tag_r11 = ctx_r22.$implicit;
    const isLast_r14 = ctx_r22.last;
    const isFirst_r13 = ctx_r22.first;
    const isOdd_r15 = ctx_r22.odd;
    const isEven_r16 = ctx_r22.even;
    const i_r12 = ctx_r22.index;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", tag_r11.thLink.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(4, _c1, isLast_r14 ? "last" : "", isFirst_r13 ? "first" : "", isOdd_r15 ? "odd" : "", isEven_r16 ? "even" : "", "tag-" + i_r12, ctx_r19.selectMainAreaArray.indexOf(tag_r11.thMainArea) > -1 ? "active" : ctx_r19.isMoreThenNull ? "hidden" : ""));
    ɵngcc0.ɵɵattribute("main-area", tag_r11.thMainArea);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(tag_r11.tag);
} }
function TagHighlightComponent_div_0_ng_container_7_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    const isLast_r14 = ctx_r23.last;
    const isFirst_r13 = ctx_r23.first;
    const isOdd_r15 = ctx_r23.odd;
    const isEven_r16 = ctx_r23.even;
    const i_r12 = ctx_r23.index;
    const tag_r11 = ctx_r23.$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(3, _c1, isLast_r14 ? "last" : "", isFirst_r13 ? "first" : "", isOdd_r15 ? "odd" : "", isEven_r16 ? "even" : "", "tag-" + i_r12, ctx_r21.selectMainAreaArray.indexOf(tag_r11.thMainArea) > -1 ? "active" : ctx_r21.isMoreThenNull ? "hidden" : ""));
    ɵngcc0.ɵɵattribute("main-area", tag_r11.thMainArea);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(tag_r11.tag);
} }
function TagHighlightComponent_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TagHighlightComponent_div_0_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(2, TagHighlightComponent_div_0_ng_container_7_ng_template_2_Template, 3, 11, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, TagHighlightComponent_div_0_ng_container_7_ng_template_4_Template, 2, 10, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tag_r11 = ctx.$implicit;
    const _r18 = ɵngcc0.ɵɵreference(3);
    const _r20 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tag_r11.thLink)("ngIfThen", _r18)("ngIfElse", _r20);
} }
function TagHighlightComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "p", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtemplate(5, TagHighlightComponent_div_0_ng_container_5_Template, 3, 9, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵtemplate(7, TagHighlightComponent_div_0_ng_container_7_Template, 6, 3, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.activeElement);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.data.tagHighlight.thTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.mainAreaTmp);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.data.tagHighlight.tags);
} }
class TagHighlightService {
    constructor() { }
}
TagHighlightService.ɵfac = function TagHighlightService_Factory(t) { return new (t || TagHighlightService)(); };
TagHighlightService.ɵprov = i0.ɵɵdefineInjectable({ factory: function TagHighlightService_Factory() { return new TagHighlightService(); }, token: TagHighlightService, providedIn: "root" });
TagHighlightService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TagHighlightService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class TagHighlightComponent {
    constructor() {
        this.multiSelect = false;
        this.isShowOnlySelected = false;
        this.isMoreThenNull = false;
        this.mainAreaTmp = new Set();
        this.selectMainAreaArray = [];
        this.activeElement = '';
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Data', this.data);
            this.data.tagHighlight.tags.forEach((tag) => {
                this.mainAreaTmp.add(tag.thMainArea);
            });
            this.multiSelect = this.data.tagHighlight.thMultiselect;
            this.isShowOnlySelected = this.data.tagHighlight.thShowOnlySelected;
            this.isMoreThenNull = false;
        });
    }
    setActiveArea(e, count) {
        const ms = 'active-' + count;
        if (this.activeElement.includes(ms)) {
            this.activeElement = '';
        }
        else {
            this.activeElement = ms;
        }
        const currentValue = e.target.textContent;
        if (!this.multiSelect) {
            if (this.selectMainAreaArray.indexOf(currentValue) > -1) {
                this.selectMainAreaArray = [];
            }
            else {
                this.selectMainAreaArray = [];
                this.selectMainAreaArray.push(currentValue);
            }
        }
        else {
            let elemExists = false;
            if (this.selectMainAreaArray.length > 0) {
                for (let i = 0; i < this.selectMainAreaArray.length; i++) {
                    if (this.selectMainAreaArray[i] === currentValue) {
                        this.selectMainAreaArray.splice(i, 1);
                        elemExists = true;
                        break;
                    }
                }
                if (!elemExists) {
                    this.selectMainAreaArray.push(currentValue);
                }
            }
            else {
                this.selectMainAreaArray.push(currentValue);
            }
        }
        if (this.isShowOnlySelected) {
            this.isMoreThenNull = this.selectMainAreaArray.length > 0;
        }
    }
}
TagHighlightComponent.ɵfac = function TagHighlightComponent_Factory(t) { return new (t || TagHighlightComponent)(); };
TagHighlightComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TagHighlightComponent, selectors: [["lib-tag-highlight"]], inputs: { data: "data" }, decls: 1, vars: 1, consts: [["class", "tag-highlight", 3, "ngClass", 4, "ngIf"], [1, "tag-highlight", 3, "ngClass"], [1, "th-head"], [1, "title"], [1, "th-main-area"], [4, "ngFor", "ngForOf"], [1, "th-tags", "d-flex", "justify-content-star", "flex-wrap"], [3, "ngClass", "click"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["link", ""], ["nolink", ""], ["target", "_self", 1, "link-container", 3, "href"], [3, "ngClass"]], template: function TagHighlightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TagHighlightComponent_div_0_Template, 8, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf], styles: [".tag-highlight[_ngcontent-%COMP%]   .th-main-area[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:30px;overflow-x:auto;overflow-y:hidden;display:flex}.tag-highlight[_ngcontent-%COMP%]   .th-main-area[_ngcontent-%COMP%]   .ma[_ngcontent-%COMP%]{border:1px solid #eee;border-radius:40px;padding:13px 20px 14px;margin-right:15px;cursor:pointer;background-color:#eee;color:#222121;min-width:-moz-fit-content;min-width:fit-content}.tag-highlight[_ngcontent-%COMP%]   .th-main-area[_ngcontent-%COMP%]   .ma.last[_ngcontent-%COMP%]{margin-right:0}.tag-highlight[_ngcontent-%COMP%]   .th-main-area[_ngcontent-%COMP%]   .ma.active[_ngcontent-%COMP%]{background-color:#ea1d89;color:#fff;border-color:#ea1d89}.tag-highlight[_ngcontent-%COMP%]   .th-tags[_ngcontent-%COMP%]{margin-top:10px}.tag-highlight[_ngcontent-%COMP%]   .th-tags[_ngcontent-%COMP%]   .tag[_ngcontent-%COMP%]{line-height:1;border:1px solid #afafaf;border-radius:40px;padding:10px 20px;margin-right:15px;margin-bottom:15px}.tag-highlight[_ngcontent-%COMP%]   .th-tags[_ngcontent-%COMP%]   .tag.last[_ngcontent-%COMP%]{margin-right:0}.tag-highlight[_ngcontent-%COMP%]   .th-tags[_ngcontent-%COMP%]   .tag.active[_ngcontent-%COMP%]{color:#ea1d89;border-color:#ea1d89}@media only screen and (max-width: 768px){.tag-highlight[_ngcontent-%COMP%]   .th-tags[_ngcontent-%COMP%]   .tag.hidden[_ngcontent-%COMP%]{display:none}}.tag-highlight[_ngcontent-%COMP%]   .th-tags[_ngcontent-%COMP%]   .link-container[_ngcontent-%COMP%]{display:inline-flex}"] });
TagHighlightComponent.ctorParameters = () => [];
TagHighlightComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TagHighlightComponent, [{
        type: Component,
        args: [{
                selector: 'lib-tag-highlight',
                template: "<div class=\"tag-highlight\" *ngIf=\"data\" [ngClass]=\"activeElement\">\n  <div class=\"th-head\">\n    <p class=\" title\">{{data.tagHighlight.thTitle}}</p>\n  </div>\n  <div class=\"th-main-area\">\n    <ng-container *ngFor=\"let ma of mainAreaTmp; let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\">\n      <span\n          [ngClass] = \"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'', 'ma', 'ma-'+i, selectMainAreaArray.indexOf(ma)>-1?'active':'']\"\n          (click)=\"setActiveArea($event, i)\"\n      >{{ma}}</span>\n    </ng-container>\n  </div>\n  <div class=\"th-tags d-flex justify-content-star flex-wrap\">\n    <ng-container *ngFor=\"let tag of data.tagHighlight.tags; let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\">\n      <ng-container *ngIf=\"tag.thLink; then link else nolink\"></ng-container>\n      <!--<ng-container #link *ngIf=\"tag.thLink.startsWith('https://') || tag.thLink.startsWith('http://'); then extern else nolink\"></ng-container>-->\n      <ng-template #link>\n      <a class=\"link-container\"\n         href=\"{{tag.thLink.url}}\"\n         target=\"_self\"\n      >\n         <span\n               [ngClass] = \"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'', 'tag', 'tag-'+i,\n                        selectMainAreaArray.indexOf(tag.thMainArea)>-1?'active':isMoreThenNull?'hidden':'']\"\n               [attr.main-area] = \"tag.thMainArea\"\n         >{{tag.tag}}</span>\n      </a>\n      </ng-template>\n      <ng-template #nolink>\n         <span\n             [ngClass] = \"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'', 'tag', 'tag-'+i,\n                          selectMainAreaArray.indexOf(tag.thMainArea)>-1?'active':isMoreThenNull?'hidden':'']\"\n             [attr.main-area] = \"tag.thMainArea\"\n         >{{tag.tag}}</span>\n      </ng-template>\n    </ng-container>\n  </div>\n</div>\n\n\n",
                styles: [".tag-highlight .th-main-area{margin-top:10px;margin-bottom:30px;overflow-x:auto;overflow-y:hidden;display:flex}.tag-highlight .th-main-area .ma{border:1px solid #eee;border-radius:40px;padding:13px 20px 14px;margin-right:15px;cursor:pointer;background-color:#eee;color:#222121;min-width:-moz-fit-content;min-width:fit-content}.tag-highlight .th-main-area .ma.last{margin-right:0}.tag-highlight .th-main-area .ma.active{background-color:#ea1d89;color:#fff;border-color:#ea1d89}.tag-highlight .th-tags{margin-top:10px}.tag-highlight .th-tags .tag{line-height:1;border:1px solid #afafaf;border-radius:40px;padding:10px 20px;margin-right:15px;margin-bottom:15px}.tag-highlight .th-tags .tag.last{margin-right:0}.tag-highlight .th-tags .tag.active{color:#ea1d89;border-color:#ea1d89}@media only screen and (max-width: 768px){.tag-highlight .th-tags .tag.hidden{display:none}}.tag-highlight .th-tags .link-container{display:inline-flex}\n"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

class TagHighlightModule {
}
TagHighlightModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TagHighlightModule });
TagHighlightModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TagHighlightModule_Factory(t) { return new (t || TagHighlightModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TagHighlightModule, { declarations: function () { return [TagHighlightComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TagHighlightComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TagHighlightModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TagHighlightComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    TagHighlightComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of tag-highlight
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TagHighlightComponent, TagHighlightModule, TagHighlightService };

//# sourceMappingURL=scoop-lli-tag-highlight.js.map